import {
  RESOURCE_DOMAIN,
  RESOURCE_SEARCH_TYPE,
} from "@modules/resource-search/resource-search-helper.ts";
import { ResourceSearchType } from "@/modules/resource-search/resource-search-types";
import { ResourceDomain } from "@/types/lesson";

const getLabelCssClasses = (resourceDomain?: ResourceDomain) => {
  return [
    {
      moe: resourceDomain === RESOURCE_DOMAIN.MOE,
      community: resourceDomain === RESOURCE_DOMAIN.COMMUNITY,
    },
  ];
};

const getLabelKind = (searchType: ResourceSearchType): string => {
  switch (searchType) {
    case RESOURCE_SEARCH_TYPE.APP:
      return "location";
    case RESOURCE_SEARCH_TYPE.WEBSITE:
      return "external-resource";
    default:
      return "domain";
  }
};

export default {
  getLabelCssClasses,
  getLabelKind,
};
